import axios from 'axios';
import { CommonService } from './common.services';
export class NotificacionService extends CommonService {
    async sendMail(evento, acreditado, template, mailto) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/sendMail?acreditado=' + acreditado + '&evento=' + evento + '&mailTo=' + mailto + '&template=' + template, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async sendMailAcreditado(evento, acreditado, template) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/sendMailAcreditado?acreditado=' + acreditado + '&evento=' + evento + '&template=' + template, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return (response.data == "OK");
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async sendWhatsApp(evento, acreditado, template, phone) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/sendMail?acreditado=' + acreditado + '&evento=' + evento + '&phone=' + phone + '&template=' + template, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async agendarNotificacion(evento, acreditado, notificacion) {
        try {
            const response = await axios.get(this.getServerUrl() + '/mobile/agendarNotificacion?acreditado=' + acreditado + '&evento=' + evento + '&notificacion=' + notificacion, { headers: { "Authorization": this.token, "Client-ID": this.clientId } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
    async sendCustomMail(evento, subject, mailTo, mailFromName, body) {
        try {
            const customMailRequest = {};
            customMailRequest.subject = subject;
            customMailRequest.mailTo = mailTo;
            customMailRequest.mailFromName = mailFromName;
            customMailRequest.body = body;
            const response = await axios.post(this.getServerUrl() + '/mobile/sendCustomMail?evento=' + evento, { "customMailRequest": customMailRequest }, { headers: { "Authorization": this.token, "Client-ID": this.clientId, "Content-Type": "application/json", "Accept": "application/json" } });
            return response.data;
        }
        catch (error) {
            throw this.manageError(error);
        }
    }
}
